<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="პროდუქტის ფასდაკლების დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის ფასდაკლების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="salePercentageAdd"
                      class="form-control mt-2"
                      placeholder="ფასდაკლების პროცენტი"
                      autofocus="autofocus"
                      :disabled="checkInputAvailable()"
                      v-model="newPriceSalePercent"
                      v-on:input="$v.productSale.$touch"
                      v-bind:class="{
                        'error-border': $v.productSale.salePercentage.$error,
                        valid:
                          $v.productSale.salePercentage.$dirty &&
                          !$v.productSale.salePercentage.$invalid,
                      }"
                    />
                    <label for="salePercentageAdd">ფასდაკლების პროცენტი</label>
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <date-picker
                      v-model="timeRange"
                      lang="en"
                      :disabled="checkInputAvailable()"
                      range
                      :shortcuts="shortcuts"
                      confirm="true"
                    ></date-picker>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="newPointsPriceAdd"
                      class="form-control mt-2"
                      placeholder="ფასდაკლებული ფასი"
                      :disabled="true"
                      v-model="productSale.newPointsPrice"
                      v-on:input="$v.productSale.$touch"
                      v-bind:class="{
                        'error-border': $v.productSale.newPointsPrice.$error,
                        valid:
                          $v.productSale.newPointsPrice.$dirty &&
                          !$v.productSale.newPointsPrice.$invalid,
                      }"
                    />
                    <label for="newPointsPriceAdd">ფასდაკლებული ფასი</label>
                  </div>
                </div>
                <label>პროდუქტი</label>
                <autocomplete
                  :list="productsArray"
                  optionField="nameGe"
                  @input="onAutocompleteInput"
                >
                  <div slot="list-item" slot-scope="{ item }">
                    {{ item.nameGe }}
                    <br />
                    {{ item.descGe }}
                  </div>
                </autocomplete>
              </form>
            </div>
          </div>
          <div class="modal-footer mt-5">
            <button
              type="button"
              class="btn btn-danger mt-5"
              data-dismiss="modal"
            >
              დახურვა
            </button>
            <button
              v-if="!isActive"
              type="button"
              class="btn btn-success mt-5"
              :disabled="!$v.productSale.$dirty || $v.productSale.$error"
              @click="$v.productSale.$touch(), addProductSale()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActive"
              type="button"
              class="btn btn-success mt-5"
              :disabled="!$v.productSale.$dirty || $v.productSale.$error"
              @click="$v.productSale.$touch(), editProductSale()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">პროდუქტის ფასდაკლება</th>
            <th class="numeric">პროდუქტის სახელი</th>
            <th class="numeric">დაწყების თარიღი</th>
            <th class="numeric">დასრულების თარიღი</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueProductSale in productSalesArray"
            :key="valueProductSale.id"
          >
            <td data-title="პროდუქტის ფასდაკლება" class="numeric">
              {{ valueProductSale.salePercentage }}
            </td>
            <td data-title="პროდუქტის სახელი" class="numeric">
              {{ valueProductSale.productName }}
            </td>
            <td data-title="დაწყების თარიღი" class="numeric">
              {{ valueProductSale.startDate }}
            </td>
            <td data-title="დასრულების თარიღი" class="numeric">
              {{ valueProductSale.endDate }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  @click="
                    editFillInputs(valueProductSale.id), modalPrepareEdit()
                  "
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  @click="getDeleteId(valueProductSale.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5
              class="modal-title text-white"
              id="exampleModalLongTitle"
            >პროდუქტის ფასდაკლების რედაქტირება</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="salePercentageEdit"
                      class="form-control"
                      placeholder="ფასდაკლების პროცენტი"
                      autofocus="autofocus"
                      :disabled="checkInputAvailable()"
                      v-model="newPriceSalePercent"
                      v-on:input="$v.productSale.$touch"
                      v-bind:class="{'error-border': $v.productSale.salePercentage.$error, valid: $v.productSale.salePercentage.$dirty && !$v.productSale.salePercentage.$invalid}"
                    >
                    <label for="salePercentageEdit">ფასდაკლების პროცენტი</label>
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <date-picker v-model="timeRange"
                                 lang="en"
                                 :disabled="checkInputAvailable()"
                                 range
                                 :shortcuts="shortcuts"></date-picker>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-label-group">
                  <input
                    type="number"
                    id="newPointsPriceEdit"
                    class="form-control"
                    placeholder="ფასდაკლებული ფასი"
                    :disabled="true"
                    v-model="productSale.newPointsPrice"
                    v-on:input="$v.productSale.$touch"
                    v-bind:class="{'error-border': $v.productSale.newPointsPrice.$error, valid: $v.productSale.newPointsPrice.$dirty && !$v.productSale.newPointsPrice.$invalid}"
                  >
                  <label for="newPointsPriceEdit">ფასდაკლებული ფასი</label>
                </div>
                <div class="form-label-group">
                  <input
                    type="text"
                    id="productNameEdit"
                    class="form-control mt-3"
                    placeholder="პროდუქტის სახელი"
                    :disabled="true"
                    v-model="productSale.productName"
                  >
                  <label for="productNameEdit">პროდუქტის სახელი</label>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">დახურვა</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.productSale.$dirty || $v.productSale.$error"
              @click="$v.productSale.$touch(), editProductSale()"
              data-dismiss="modal"
            >რედაქტირება</button>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteProductSale()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import DatePicker from "vue2-datepicker";

export default {
  name: "productSale",
  components: { autocomplete: ProductMenuGroupTemplate, DatePicker },
  data() {
    return {
      showModal: false,
      productSale: {
        id: null,
        salePercentage: null,
        newPointsPrice: null,
        productId: null,
        productName: "",
        startDate: null,
        endDate: null,
      },
      product: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        mainImage: null,
        gallery: [],
        brandId: null,
        itemPrice: null,
        pointsPrice: null,
        pointCorrection: null,
        legalId: "",
        properties: [],
        categories: [],
        subCategories: [],
        subCategories2: [],
      },
      shortcuts: [
        {
          text: "აირჩიეთ ვადა",
          onClick: () => {
            this.productLoyalty.time = [new Date(), new Date()];
          },
        },
      ],
      isActive: false,
      productSalesArray: [],
      productsArray: [],
      timeRange: [],
      newPriceSalePercent: null,
    };
  },
  validations: {
    productSale: {
      salePercentage: {
        required,
      },
      newPointsPrice: {
        required,
      },
      startDate: {
        required,
      },
      endDate: {
        required,
      },
    },
  },
  async created() {
    let productSaleResult = await this.$http.getProductSale();
    this.productSalesArray = productSaleResult.data.res;

    let productResult = await this.$http.getProduct();
    this.productsArray = productResult.data.res;
  },
  watch: {
    timeRange(value) {
      this.productSale.startDate = value[0];
      this.productSale.endDate = value[1];
    },
    newPriceSalePercent(value) {
      let productsPrice =
        this.product.pointsPrice * (1 + this.product.pointCorrection / 100);
      let discountedPrice = productsPrice * (1 + (value / 100) * -1);
      this.productSale.newPointsPrice = Math.ceil(discountedPrice);
      this.productSale.salePercentage = Number(value);
    },
  },
  methods: {
    async addProductSale() {
      try {
        let productSaleObjectAdd = {
          salePercentage: this.productSale.salePercentage,
          newPointsPrice: this.productSale.newPointsPrice,
          productId: this.productSale.productId,
          startDate: this.productSale.startDate,
          endDate: this.productSale.endDate,
        };

        let productSaleAddResult = await this.$http.postProductSale(
          productSaleObjectAdd
        );

        if (productSaleAddResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ფასდაკლება წარმატებით დაემატა");
          let productSaleResult = await this.$http.getProductSale();
          this.productSalesArray = productSaleResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ფასდაკლების დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editProductSale() {
      try {
        let productSaleObjectEdit = {
          id: this.productSale.id,
          salePercentage: this.productSale.salePercentage,
          newPointsPrice: this.productSale.newPointsPrice,
          startDate: this.productSale.startDate,
          endDate: this.productSale.endDate,
        };

        let productSaleEditResult = await this.$http.putProductSale(
          productSaleObjectEdit
        );

        if (productSaleEditResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ფასდაკლება წარმატებით დარედაქტირდა");
          let productSaleResult = await this.$http.getProductSale();
          this.productSalesArray = productSaleResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ფასდაკლების რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteProductSale() {
      try {
        let productSaleDeleteResult = await this.$http.deleteProductSale(
          this.productSale.id
        );

        if (productSaleDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ფასდაკლება წარმატებით წაიშალა");
          let productSaleResult = await this.$http.getProductSale();
          this.productSalesArray = productSaleResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ფასდაკლების წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(id) {
      this.timeRange = [];
      let productSaleResult = await this.$http.getByIDProductSale(id);
      this.productSale = productSaleResult.data.res;
      let productResult = await this.$http.getByIDProduct(
        productSaleResult.data.res.productId
      );
      this.product = productResult.data.res;
      this.newPriceSalePercent = productSaleResult.data.res.salePercentage;
      this.timeRange.push(productSaleResult.data.res.startDate);
      this.timeRange.push(productSaleResult.data.res.endDate);
    },
    onAutocompleteInput(object) {
      this.productSale.productId = object.id;
      this.productSale.productName = object.nameGe;
      this.product = object;
    },
    checkInputAvailable() {
      if (this.productSale.productId) {
        return false;
      } else {
        return true;
      }
    },
    getDeleteId(id) {
      this.productSale.id = id;
    },
    modalPrepareEdit() {
      this.isActive = true;
    },
    modalPrepare() {
      this.isActive = false;
    },
    clearData() {
      this.productSale.id = null;
      this.productSale.salePercentage = null;
      this.productSale.newPointsPrice = null;
      this.productSale.productId = null;
      this.productSale.productName = "";
      this.productSale.startDate = null;
      this.productSale.endDate = null;
      this.product.id = null;
      this.product.nameGe = "";
      this.product.nameEn = "";
      this.product.nameRu = "";
      this.product.descGe = "";
      this.product.descEn = "";
      this.product.descRu = "";
      this.product.mainImage = null;
      this.product.gallery = [];
      this.product.brandId = null;
      this.product.itemPrice = null;
      this.product.pointsPrice = null;
      this.product.pointCorrection = null;
      this.product.legalId = "";
      this.product.properties = [];
      this.product.categories = [];
      this.product.subCategories = [];
      this.product.subCategories2 = [];
      this.timeRange = [];
      this.newPriceSalePercent = null;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

// .error-border {
//   border-color: #ffb3b3;
//   box-shadow: none;
// }
// .editBtn {
//   margin-left: 10px;
//   font-size: 30px;
//   cursor: pointer;
//   color: #52af8e;
// }
// .deleteBtn {
//   font-size: 30px;
//   cursor: pointer;
//   color: #d43f3a;
//   margin-left: 10px;
// }

// .searchBtn {
//   font-size: 40px;
//   margin-top: -5px;
//   cursor: pointer;
//   color: #489d7f;
// }

// .addNewBtn {
//   font-size: 44px;
//   margin-left: 15px;
//   cursor: pointer;
//   color: #52af8e;
//   margin-top: -5px;
// }

// @media only screen and (min-width: 1450px) {
//   #no-more-tables table {
//     border-style: none;
//   }
//   #no-more-tables th {
//     padding: 12px;
//     font-weight: bold;
//     border-style: none;
//     border-bottom: solid #212529 4px;
//   }
//   #no-more-tables td {
//     padding: 10px;
//     font-family: "BPGNinoMtavruli";
//     border-style: none;
//     border-bottom: solid #212529 2px;
//   }
// }

// @media only screen and (max-width: 1450px) {
//   .deleteBtn {
//     margin-left: 5px;
//   }
//   #no-more-tables table,
//   #no-more-tables thead,
//   #no-more-tables tbody,
//   #no-more-tables th,
//   #no-more-tables td,
//   #no-more-tables tr {
//     display: block;
//     border-style: none;
//   }
//   #no-more-tables thead tr {
//     position: absolute;
//     top: -9999px;
//     left: -9999px;
//   }
//   #no-more-tables tr {
//     border-bottom: 4px solid #212529;
//   }
//   #no-more-tables td {
//     border-bottom: 1px solid #eee;
//     position: relative;
//     padding-left: 50%;
//     white-space: normal;
//     text-align: left;
//   }
//   #no-more-tables td:before {
//     position: absolute;
//     top: 6px;
//     left: 6px;
//     width: 45%;
//     padding-right: 10px;
//     white-space: nowrap;
//     text-align: left;
//     font-weight: bold;
//   }
//   #no-more-tables td:before {
//     content: attr(data-title);
//   }
// }
// @media only screen and (max-width: 600px) {
//   .container {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
//   #no-more-tables table {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/view/ProductSale.vue